<template lang="pug">
  .w-100.mh-100.h-100
    div.item-block-body(ref="divGeofences")
      .tr
        .th.p-2 Геозоны:
        .td.py-2(v-if="!reportData.IsSummary")
          .area-objects-create
            div(v-for="geofence in reportData.Data.Data.Geofences")
              em.d-flex.mb-2.mr-4 {{ geofence }}
        .td.py-2(v-if="reportData.IsSummary && reportData.Data.Data[0]")
          .area-objects-create
            div(v-for="geofence in reportData.Data.Data[0].Geofences")
              em.d-flex.mb-2.mr-4 {{ geofence }}
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localGeoHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="reportData.IsSummary ? summary : null"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'GeofencesCrossing',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'GeofenceName',
        caption: 'Название геозоны',
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        alignment: 'center',
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Конец',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        alignment: 'center',
        width: 150,
      }],
      summary: {
        groupItems: [{
          column: 'IntersectionsNumber',
          summaryType: 'count',
          displayFormat: 'количество пересечений: {0}',
        }],
      },
      reportSummary: [],
      sortableField: null,
      rowClick: null,
      heightGeo: 96,
    };
  },
  computed: {
    localGeoHeight () {
      return `calc(${this.localHeight} - ${this.heightGeo}px)`;
    },
  },
  watch: {
    reportData (value) {
      this.sortableField = null;
      this.rowClick = null;
      this.heightGeo = this.$refs.divGeofences?.clientHeight;
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.heightGeo = this.$refs.divGeofences?.clientHeight;
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        //
      }
    },

    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },
  },
};
</script>
<style lang="stylus" scoped>

.item-block-body {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  .mt {
    padding: 6px 0;
  }
  .tr {
    display: flex;
    width: 100%;
    .th {
      width: 80px;
      min-width: 80px;
    }
    .td {
      color: #555;
      width: 100%;
    }
  }
}

.area-objects-create {
  overflow-y: auto;
  max-height: 80px;
  display: flex;
  flex-wrap: wrap;
}
</style>
